// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ba95336ee5fa166f911f","453":"2050cc4c090f75df33dd"}[chunkId] + ".js";
};